var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 15 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M13.3333 3.88151L8.36393 7.04688C8.35636 7.05169 8.3489 7.05669 8.34115 7.0612C8.03611 7.23837 7.68934 7.33134 7.33659 7.33138C6.98382 7.33138 6.6371 7.23835 6.33203 7.0612C6.32425 7.05668 6.31619 7.05171 6.30859 7.04688L1.33333 3.88086V10C1.33333 10.3682 1.63181 10.6667 2 10.6667H12.6667C13.0349 10.6667 13.3333 10.3682 13.3333 10V3.88151ZM13.3333 2C13.3333 1.63181 13.0349 1.33333 12.6667 1.33333H2C1.63181 1.33333 1.33333 1.63181 1.33333 2V2.30013L7.00521 5.91016C7.10602 5.96787 7.22038 5.99805 7.33659 5.99805C7.45248 5.998 7.56607 5.9676 7.66667 5.91016L13.3333 2.30013V2ZM14.6667 10C14.6667 11.1046 13.7712 12 12.6667 12H2C0.89543 12 0 11.1046 0 10V2C0 0.895431 0.895431 0 2 0H12.6667C13.7712 0 14.6667 0.895431 14.6667 2V10Z",
          fill: _vm.fill,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }